export default __webpack_public_path__ + "static/media/3.SILO_REPOSO.82b06286.jpg";